import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getCampaignMembersCount = async (selectedDomain: string, campaignId: number, segmentIds: number[], consentRule: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/members-count?domain=${selectedDomain}&segmentIds=${segmentIds}&consentRule=${consentRule}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}